import { render, staticRenderFns } from "./registerProtocolList.vue?vue&type=template&id=4b226b5a&scoped=true"
import script from "./registerProtocolList.vue?vue&type=script&lang=js"
export * from "./registerProtocolList.vue?vue&type=script&lang=js"
import style0 from "./registerProtocolList.vue?vue&type=style&index=0&id=4b226b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b226b5a",
  null
  
)

export default component.exports